import { render, staticRenderFns } from "./WebNotificationsButton.vue?vue&type=template&id=66b45d48&scoped=true&"
import script from "./WebNotificationsButton.vue?vue&type=script&lang=js&"
export * from "./WebNotificationsButton.vue?vue&type=script&lang=js&"
import style0 from "./WebNotificationsButton.vue?vue&type=style&index=0&id=66b45d48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b45d48",
  null
  
)

export default component.exports